// Added by Sejune Oh on 2020-03-20
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react'
import { createStyles, makeStyles } from '@material-ui/core'
import clsx from 'clsx'

// Intl
import Intl from '@/helper/Intl'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
export interface TaskMonitoringBoxProps {
  /** Task Label */
  taskText?: string
  /** Waiting Tasks Label */
  waitingText?: string
  /** Waiting Tasks Count */
  waitingCount: number
  /** Running Tasks Label */
  runningText?: string
  /** Running Tasks Count */
  runningCount: number
  onBoxClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  /** WC용 Styles  */
  classes?: any
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * [Tasks]의 상태를 볼 수 있는 수치 UI 입니다.
 */
const TaskMonitoringBox: FC<TaskMonitoringBoxProps> = ({
  taskText: taskTextParam,
  waitingCount,
  waitingText: waitingTextParam,
  runningCount,
  runningText: runningTextParam,
  onBoxClick,
  classes: webComponentClassses,
  ...props
}) => {
  const classes = webComponentClassses
    ? webComponentClassses['taskmonitoringbox']
    : makeStyles(() => createStyles({ ...customStyles }))()

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // ! I18n
  const taskText = taskTextParam || Intl.getIntlText({ id: 'htmljs_react.worklist.taskmonitoringbox.label_tasks' })
  const waitingText = waitingTextParam || Intl.getIntlText({ id: 'htmljs_react.worklist.taskmonitoringbox.label_waiting' })
  const runningText = runningTextParam || Intl.getIntlText({ id: 'htmljs_react.worklist.taskmonitoringbox.label_running' })

  return (
    <div className={classes.wrapper} onClick={onBoxClick}>
      <div className={classes.firstRow}>{taskText}</div>
      <div className={classes.secondRow}>
        <span className={clsx({ 'active': runningCount > 0 })}>
          {runningText} <strong>{runningCount}</strong>
        </span>
        <span>{'/'}</span>
        <span>
          {waitingText} <strong>{waitingCount}</strong>
        </span>
      </div>
    </div>
  )
}

export const customStyles: Record<string, any> = {
  wrapper: {
    display: 'flex',
    backgroundColor: '#1a1a1a',
    fontSize: '11px',
    width: '160px',
    height: '46px',
    flexDirection: 'column',
    padding: '5px 8px',
    boxSizing: 'border-box',
    justifyContent: 'space-between',
    color: '#fff',
    cursor: 'pointer'
  },
  firstRow: {},
  secondRow: {
    justifyContent: 'center',
    paddingBottom: '4px',
    display: 'flex',
    '& > span': {
      '&.active': {
        color: '#6D973F',
      },
      '&:nth-child(2)': {
        margin: '0 4px',
      },
      color: '#A6A6A6',
      '& > strong': {
        fontWeight: 900,
        color: '#fff'
      }
    },
  }
}

export default TaskMonitoringBox
